import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { REACT_APP_API_URL } from "../../env";

const ChangePassword = () => {

  const navigate = useNavigate();

  const userId = localStorage.getItem("userId"); 

  const [oldPassword,setOldPassword] = useState("");
  const [newPassword,setNewPassword] = useState("");
  const [confirmPassword,setConfirmPassword] = useState("");

  const [showOld,setShowOld] = useState(false);
  const [showNew,setShowNew] = useState(false);
  const [showConfirm,setShowConfirm] = useState(false);

  const [loading,setLoading] = useState(false);

  const handleSubmit = async(e)=>{
    e.preventDefault();

    if(!oldPassword || !newPassword || !confirmPassword){
      toast.error("All fields are required");
      return;
    }

    if(newPassword !== confirmPassword){
      toast.error("Passwords do not match");
      return;
    }

    const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;

    if(!passwordRegex.test(newPassword)){
      toast.error("Password must contain uppercase, lowercase and number");
      return;
    }

    try{

      setLoading(true);

      const res = await axios.post(
        `${REACT_APP_API_URL}/api/auth/change-password`,
        {
          userId:userId,
          oldPassword:oldPassword,
          newPassword:newPassword
        },
        {withCredentials:true}
      );

      toast.success(res.data.message);
      localStorage.removeItem("userId");

      setTimeout(()=>{
        navigate("/login");
      },1500);

    }
    catch(error){

      toast.error(
        error.response?.data?.message ||
        "Failed to change password"
      );

    }
    finally{
      setLoading(false);
    }

  }

  return (

  <div
  className="login-background-image d-flex justify-content-center align-items-center"
  style={{minHeight:"100vh"}}
  >

  <div className="container" style={{maxWidth:"400px"}}>

  <form
  className="p-4 rounded text-center"
  style={{backgroundColor:"rgba(63,61,61,0.7)"}}
  onSubmit={handleSubmit}
  >

  <h5 className="text-white mb-3">Change Password</h5>

  {/* OLD PASSWORD */}

  <div className="form-group-signup position-relative">

  <input
  type={showOld ? "text":"password"}
  className="form-control"
  placeholder="Enter Old Password"
  value={oldPassword}
  onChange={(e)=>setOldPassword(e.target.value)}
  required
  />

  <span
  style={{
  position:"absolute",
  right:"15px",
  top:"10px",
  cursor:"pointer"
  }}
  onClick={()=>setShowOld(!showOld)}
  >
  {showOld ? <FaEyeSlash/> : <FaEye/>}
  </span>

  </div>

  {/* NEW PASSWORD */}

  <div className="form-group-signup position-relative mt-3">

  <input
  type={showNew ? "text":"password"}
  className="form-control"
  placeholder="Enter New Password"
  value={newPassword}
  onChange={(e)=>setNewPassword(e.target.value)}
  required
  />

  <span
  style={{
  position:"absolute",
  right:"15px",
  top:"10px",
  cursor:"pointer"
  }}
  onClick={()=>setShowNew(!showNew)}
  >
  {showNew ? <FaEyeSlash/> : <FaEye/>}
  </span>

  </div>

  {/* CONFIRM PASSWORD */}

  <div className="form-group-signup position-relative mt-3">

  <input
  type={showConfirm ? "text":"password"}
  className="form-control"
  placeholder="Confirm New Password"
  value={confirmPassword}
  onChange={(e)=>setConfirmPassword(e.target.value)}
  required
  />

  <span
  style={{
  position:"absolute",
  right:"15px",
  top:"10px",
  cursor:"pointer"
  }}
  onClick={()=>setShowConfirm(!showConfirm)}
  >
  {showConfirm ? <FaEyeSlash/> : <FaEye/>}
  </span>

  </div>

  <button
  type="submit"
  className="btn btn-success w-100 mt-3"
  disabled={loading}
  >
  {loading ? "Updating..." : "Change Password"}
  </button>

  </form>

  </div>

  </div>

  );
};

export default ChangePassword;